import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '../views/Index.vue'),
    meta: {
      keepAlive: false,
    }
  },
  {
    path: '/companyIntroduction',
    name: 'CompanyIntroduction',
    component: () => import(/* webpackChunkName: "about" */ '../views/CompanyIntroduction/CompanyIntroduction.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/globalMarket',
    name: 'GlobalMarket',
    component: () => import(/* webpackChunkName: "about" */ '../views/CompanyIntroduction/GlobalMarket.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/details',
    name: 'Details',
    component: () => import(/* webpackChunkName: "about" */ '../views/CompanyIntroduction/Details.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/manufacture',
    name: 'Manufacture',
    component: () => import(/* webpackChunkName: "about" */ '../views/CompanyIntroduction/Manufacture.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/inviteInvestment',
    name: 'InviteInvestment',
    component: () => import(/* webpackChunkName: "about" */ '../views/InviteInvestment/InviteInvestment.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/bkl',
    name: 'Bkl',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProjectIntroduction/Bkl.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/site',
    name: 'Site',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProjectIntroduction/Site.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/wuhua',
    name: 'WH',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProjectIntroduction/WH.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/articleList',
    name: 'ArticleList',
    component: () => import(/* webpackChunkName: "about" */ '../views/Article/ArticleList.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/articleList1',
    name: 'ArticleList',
    component: () => import(/* webpackChunkName: "about" */ '../views/Article/ArticleList1.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/articleDetails',
    name: 'ArticleDetails',
    component: () => import(/* webpackChunkName: "about" */ '../views/Article/ArticleDetails.vue'),
    meta: {
      keepAlive: true,
    }
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
